import styled, { css } from 'styled-components';

import CommonContainer from 'ggApp/shared/common/Container';
import { elevation, elevationTransition, transition } from 'ggApp/utils/mixins';

import ItemComponent from './Item';
import OverlayComponent from './Overlay';

const MAIN_BACKGROUND = 'rgba(23, 204, 168, 0.1)';

const Wrap = styled(CommonContainer)``;

const Grid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit,minmax(120px, 1fr));
    grid-gap: 16px;
    ${(props) => props.theme.superQuery.all.and.maxWidth.tabletMax.css`
        grid-template-columns: repeat(auto-fit,minmax(140px, 1fr));
    `}
    ${(props) => props.theme.superQuery.all.and.maxWidth.mobileMax.css`
        grid-template-columns: repeat(2, 1fr);
    `}
    visibility: hidden;
    opacity: 0;
    transform: scale(0.9);
    width: 100%;
    ${transition('all', '0.2s', 'out')};
    ${({ shouldShow }) => shouldShow
        && css`
            visibility: visible;
            opacity: 1;
            transform: scale(1);
            ${transition('all', '0.2s', 'in')};
        `}
`;

const Item = styled(ItemComponent)`
    cursor: pointer;
    ${elevation(0, false)}
    ${elevationTransition(false)}
    &:hover,
    &:focus {
        background-color: ${({ theme }) => theme.colors.Background};
        ${elevation(2, false, MAIN_BACKGROUND, MAIN_BACKGROUND)};
    }
    &:active {
        background-color: ${({ theme }) => theme.colors.Background};
        ${elevation(1, false, MAIN_BACKGROUND, MAIN_BACKGROUND)};
    }
`;
const Overlay = styled(OverlayComponent)`
    height: 100%;
    width: 100%;
    position: absolute;
    visibility: hidden;
    opacity: 0;
    transform: scale(0.9);
    ${transition('all', '0.2s', 'out')};
    ${({ shouldShow }) => shouldShow
        && css`
            visibility: visible;
            opacity: 1;
            transform: scale(1);
            ${transition('all', '0.2s', 'in')};
        `}
`;

const Icon = styled.img`
    height: 24px;
    width: 24px;
`;

export {
    Wrap, Grid, Item, Overlay, Icon,
};
